// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1fW_i","clinicsSelect":"TableHeading_clinicsSelect__2oItn"};